/*
    This directive will flash whatever you want for 3 seconds.
    Ex: <div ns-flash="flash"><p>Flash this message</p></div>
    if when $scope.flash is set to true the contents will flash 3 times and the color will change to red
 */
import {utilModule} from '../module.js';

utilModule.directive('nsFlash', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            scope.$watch(attrs.nsFlash, function() {
                if (scope.$eval(attrs.nsFlash)) {
                    element.css('color', 'red');

                    // Flash three times.
                    for (let i = 0; i < 3; i++) {
                        element.fadeTo('slow', 0.2).fadeTo('slow', 1.0);
                    }
                }
            });
        }
    };
});
